import axios from 'axios'

export const getPrediction = async (payload) => {
  try {
    const res = await axios.post(`http://58.181.99.181:8000/predict`, payload)
    //   const res = await privateAPI.post(`/member/create-member`, payload)
    if (res) {
      console.log(res?.data)
      // return res.data
    }
  } catch (err) {
    console.log(err)
  }
}
